/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import {
    CategoryScale,
    Chart as ChartJS,
    Legend,
    LinearScale,
    LineElement,
    PointElement,
    TimeScale,
    Title,
    Tooltip,
} from 'chart.js';
import {Line} from "react-chartjs-2";
import 'chartjs-adapter-luxon';

ChartJS.register(
    CategoryScale,
    TimeScale, //Register timescale instead of category for X axis
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

class ChartBase extends Component {
    render() {
        const {
            titel,
            data,
            unit = '',
            max = undefined,
            color = 'rgb(99, 102, 241)',
            label = titel,
        } = this.props;

        const options = {
            responsive: true,
            maintainAspectRatio: false,
            interaction: {mode: 'index', intersect: false},
            plugins: {
                title: {display: true, text: titel},
                tooltip: {
                    callbacks: {
                        label: (ctx) => `${ctx.parsed.y}${unit}`,
                    },
                },
            },
            scales: {
                x: {
                    type: 'time',
                    time: {unit: 'minute', tooltipFormat: 'HH:mm'},
                    title: {display: true, text: 'Time'},
                },
                y: {
                    min: 0,
                    max,
                    title: {display: !!unit, text: unit},
                    ticks: {callback: (val) => `${val}${unit}`},
                },
            },
        };

        const chartData = {
            datasets: [
                {
                    label,
                    data,
                    fill: false,
                    borderColor: color,
                    backgroundColor: color,
                    tension: 0.25,
                    pointRadius: 0,
                    pointHoverRadius: 0
                },
            ],
        };

        return <div className={"h-70 w-full p-2 bg-white"}>
            <Line options={options} data={chartData}/>
        </div>
    }
}


ChartBase.propTypes = {};

ChartBase.defaultProps = {};


export default ChartBase;